var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRaisedHand = function SvgRaisedHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.917 3.208v8.709a.917.917 0 0 0 1.833 0V4.833c0-.097.168-.25.458-.25.29 0 .459.153.459.25v7.084a.917.917 0 0 0 1.833 0V6.875a.458.458 0 1 1 .917 0v6.913c-.25 2.552-2.425 4.545-5.042 4.545a5.037 5.037 0 0 1-4.205-2.258l-.003.001-3.495-5.255c-.168-.24-.117-.526.09-.671a.458.458 0 0 1 .638.112l1.173 1.753h-.001a.917.917 0 0 0 1.676-.482h.002V5.043a.458.458 0 0 1 .917-.001V11.918a.917.917 0 0 0 1.833 0V3.208a.458.458 0 1 1 .917 0Zm7.317 10.56.016-.008V6.876a2.292 2.292 0 0 0-2.76-2.244c-.112-1.055-1.091-1.881-2.282-1.881-.17 0-.335.017-.495.049a2.292 2.292 0 0 0-4.51.004 2.292 2.292 0 0 0-2.786 2.238v3.663a2.293 2.293 0 0 0-3.27 3.135l3.302 4.94a6.875 6.875 0 0 0 12.785-3.01Z"
  })));
};

export default SvgRaisedHand;